import React from 'react';
import {SidebarItemBadge} from '../SidebarItemBadge';
import {useConversationCounts} from '../ConversationsBadge/ConversationCountsContext';

type Props = {
  children: React.ReactNode;
};

export const MessagesBadge = (props: Props) => {
  const {counts} = useConversationCounts();

  return (
    <SidebarItemBadge badgeContent={counts.needsResponse || 0}>
      {props.children}
    </SidebarItemBadge>
  );
};
